'use strict';

const EventEmitter = require('events').EventEmitter;
const confirmCancelLoanpartSale = require('./confirm-loanpart-sale-cancellation');
const emitter = module.exports = new EventEmitter();
const $ = require('jquery');
const transitionEnd = require('transitionend-property');

const options = {
	triggerClassName: 'js-inline-table-sort',
	loadingClassName: 'is-loading',
	spinnerVisibleClassName: 'is-active',
	minimumSpinnerDuration: 300
};

const state = {
	loading: false
};

$('body').on('click', `.${options.triggerClassName}`, function(e) {

	e.preventDefault();

	if(state.loading) {
		return;
	}

	const $trigger = $(this);
	const href = $trigger.attr('href');
	const target = $trigger.data('table');
	const $target = $(`#${target}`);
	const $spinner = $target.siblings('.js-spinner');

	$target.addClass(options.loadingClassName);
	$spinner.addClass(options.spinnerVisibleClassName);
	state.loading = true;

	$.get(href).done(res => {

		setContent($target, res);
		$target.removeClass(options.loadingClassName);

		setTimeout(() => {
			state.loading = false;
			$spinner.on(transitionEnd, () => $spinner.remove());
			$spinner.removeClass(options.spinnerVisibleClassName);
		}, options.minimumSpinnerDuration);

	});

});

function setContent($target, content) {

	if($target.length < 1) {
		return;
	}

	const $content = $(content);

	const id = $content
		.find('[id]')
		.first()
		.attr('id');

	$target.replaceWith($content);
	confirmCancelLoanpartSale($content.find('.js-cancel-loanpart-sale'));
	emitter.emit('append', id);

}